export default {"src":"/_next/static/media/Merci_small.c7c4aa1e.svg","height":193,"width":192,"blurWidth":0,"blurHeight":0};